module.exports = __webpack_public_path__ + "img/ex-pin-year-round-golf.d43ac7e8.svg";